import type { Joi } from '@ksyos/koi';

// Any return type because typing of ValidationErrorFunction of joi is not correct. Adding custom typing results in copying complete index.d.ts file.
export function replaceKoiError(errors: Joi.ErrorReport[], oldErrorCode: string, newErrorCode: string): any {
    const validationItem = errors.find((err) => err.code === oldErrorCode);
    if (validationItem) {
        validationItem.code = newErrorCode;
    }

    return errors;
}
